
// CharacterAnimation.js
import React, { useRef, useEffect, useState } from 'react';
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const CharacterAnimation = ({ children }) => {

  const ref = useRef(null);
  const [isMobileForParallax500, setIsMobileForParallax500] = useState(window.innerWidth <= 500);

  useEffect(() => {
    if (typeof window !== "undefined") {
    
      const checkIfMobile500 = () => {
        setIsMobileForParallax500(window.innerWidth <= 500);
    };

    window.addEventListener('resize', checkIfMobile500);

    return () => window.removeEventListener('resize', checkIfMobile500);
  }
}, []);

  useEffect(() => {
    if (typeof window !== "undefined" && ref.current) {
      // Délai plus long pour être sûr que ScrollTrigger est prêt
      const timer = setTimeout(() => {
        const elements = ref.current ? ref.current.children : [];
        
        if (elements.length > 0 && typeof ScrollTrigger !== 'undefined') {
          // Vérifier que ScrollTrigger existe avant de l'utiliser
          try {
            const tl = gsap.timeline({
              scrollTrigger: {
                trigger: ref.current,
                start: "top center+=100",
                toggleActions: "play none none reverse",
                once: true,
              }
            });
        
            tl.fromTo(elements, { autoAlpha: 0, y: 30 }, {
              duration: 0.6,
              autoAlpha: 1,
              y: 0,
              ease: "back.out(3)",
              stagger: 0.05, // 0.05 second delay between each character
            });
        
            const st = ScrollTrigger.create({
              trigger: ref.current,
              start: "top center",
              onEnterBack: () => {
                gsap.fromTo(elements, { autoAlpha: 0, y: 30 }, { autoAlpha: 1, y: 0, stagger: 0.05 });
              },
            });
        
            // Cleanup function
            return () => {
              tl.kill();
              st.kill();
            };
          } catch (error) {
            // Si ScrollTrigger n'est pas prêt, faire une animation simple
            gsap.fromTo(elements, 
              { autoAlpha: 0, y: 30 }, 
              { 
                autoAlpha: 1, 
                y: 0, 
                stagger: 0.05,
                duration: 0.6,
                ease: "back.out(3)"
              }
            );
          }
        }
      }, 500); // Délai augmenté à 500ms

      return () => clearTimeout(timer);
    }
  }, []);
  

  return <span ref={ref}>{children}</span>;
};

export default CharacterAnimation;


// CharacterAnimation.js

// import React, { useRef, useEffect, useState } from 'react';
// import { gsap } from "gsap";
// import { ScrollTrigger } from 'gsap/ScrollTrigger';

// const CharacterAnimation = ({ children }) => {
//   const ref = useRef(null);
//   const [isMobileForParallax500, setIsMobileForParallax500] = useState(window.innerWidth <= 500);

//   useEffect(() => {
//     const checkIfMobile500 = () => {
//       setIsMobileForParallax500(window.innerWidth <= 500);
//     };
    
//     // Ajouter l'écouteur d'événements
//     window.addEventListener('resize', checkIfMobile500);
    
//     // Supprimer l'écouteur d'événements lors du nettoyage
//     return () => window.removeEventListener('resize', checkIfMobile500);
//   }, []);

//   useEffect(() => {
//     if (typeof window !== "undefined") {
//       gsap.registerPlugin(ScrollTrigger);
//       const elements = ref.current ? ref.current.children : [];
      
//       const tl = gsap.timeline({
//         scrollTrigger: {
//           trigger: ref.current,
//           start: "top center+=100",
//           toggleActions: "play none none reverse",
//           once: true,
//         }
//       });

//       // Déterminer la direction de l'animation en fonction de la largeur de la fenêtre
//       const direction = isMobileForParallax500 ? 1 : -1;
      
//       tl.fromTo(elements, { autoAlpha: 0, y: () => 30 * direction }, {
//         duration: 0.6,
//         autoAlpha: 1,
//         y: 0,
//         ease: "back.out(3)",
//         stagger: 0.05, // 0.05 second delay between each character
//       });
      
//       const st = ScrollTrigger.create({
//         trigger: ref.current,
//         start: "top center",
//         onEnterBack: () => {
//           gsap.fromTo(elements, { autoAlpha: 0, y: () => 30 * direction }, { autoAlpha: 1, y: 0, stagger: 0.05 });
//         },
//       });
      
//       // Cleanup function
//       return () => {
//         tl.kill();
//         st.kill();
//       };
//     }
//   }, [isMobileForParallax500]); // Ajouter isMobileForParallax500 aux dépendances pour mettre à jour l'animation lors d'un changement de taille

//   return <span ref={ref}>{children}</span>;
// };

// export default CharacterAnimation;
